import {
  EnvelopeSimpleIcon,
  EyeClosedIcon,
  EyeIcon,
  LockSimpleIcon,
  PhoneIcon,
  UserIcon,
} from "@phosphor-icons/react";
import ikas from "../../providers/ikas";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Register({ data, dataSetter }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [revealPassword, setRevealPassword] = useState(false);
  const [revealConfirmPassword, setRevealConfirmPassword] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [toastType, setToastType] = useState("success"); // success | error
  const [rememberMe, setRememberMe] = useState(true);

  // Validation helpers
  const validateName = (val) => val.trim().length > 1;
  const validateSurname = (val) => val.trim().length > 1;
  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
  const validatePhone = (val) => /^\+90\d{10}$/.test(val);
  const validatePassword = (val) => val.length >= 6;

  const [touched, setTouched] = useState({});
  const [invalid, setInvalid] = useState({});
  const onRememberMeChange = () => setRememberMe((prev) => !prev);

  const handleBlur = (field) =>
    setTouched((prev) => ({ ...prev, [field]: true }));
  const handleInput = (field, value) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
    setInvalid((prev) => ({ ...prev, [field]: false }));
  };

  const handleRegister = () => {
    setErrorMessages([]);
    const newInvalid = {
      name: !validateName(name),
      surname: !validateSurname(surname),
      email: !validateEmail(email),
      phone: !validatePhone(phone),
      password: !validatePassword(password),
      confirmPassword:
        password !== confirmPassword || !validatePassword(confirmPassword),
    };
    setInvalid(newInvalid);
    setTouched({
      name: true,
      surname: true,
      email: true,
      phone: true,
      password: true,
      confirmPassword: true,
    });
    if (Object.values(newInvalid).some(Boolean)) {
      setErrorMessages([{ message: "Lütfen tüm alanları doğru doldurun." }]);
      return;
    }
    setLoading(true);
    ikas
      .registerCustomer(email, password, name, surname, phone, rememberMe)
      .then((response) => {
        setLoading(false);
        dataSetter(response);
        setToast("Kayıt işlemi başarılı");
        setShowToast(true);
        setTimeout(() => {
          setShowToast(false);
          setTimeout(() => {
            setToast("");
            navigate("/account");
          }, 400);
        }, 1200);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setErrorMessages([{ message: "Kayıt sırasında bir hata oluştu." }]);
      });
  };

  const onPrivacyPolicyClick = () => {
    navigate("/privacy-policy");
  };
  const onLoginClick = () => {
    navigate("/login");
  };

  return (
    <div className="relative">
      {toast && (
        <div
          className={`fixed left-1/2 transform -translate-x-1/2 z-[100] w-[95vw] max-w-xl px-6 py-3 rounded-lg shadow-lg text-base font-semibold text-center transition-all duration-400
            ${
              showToast
                ? "opacity-100 translate-y-0"
                : "opacity-0 -translate-y-4 pointer-events-none"
            }`}
          style={{
            minWidth: 320,
            top: data?.system?.safeArea?.top ?? 20,
            backgroundColor: toastType === "error" ? "#ef4444" : "#6f59ef",
            color: "#fff",
          }}
        >
          {toast}
        </div>
      )}
      {loading && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-40 transition-opacity duration-200"
          style={{ pointerEvents: "none" }}
        ></div>
      )}

      <div className="mx-1  flex flex-col items-center min-h-screen">
        <div className="w-full max-w-sm min-w-[200px] flex flex-col gap-4 mx-auto bg-white p-4 rounded-lg  relative sm:max-w-md md:max-w-lg">
          {/* Name */}
          <div className="relative">
            <UserIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
            <input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
                handleInput("name", e.target.value);
              }}
              onBlur={() => handleBlur("name")}
              type="text"
              className={`w-full pl-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow ${
                invalid.name && touched.name
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
              placeholder="İsim"
            />
          </div>
          {/* Surname */}
          <div className="relative">
            <UserIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
            <input
              value={surname}
              onChange={(e) => {
                setSurname(e.target.value);
                handleInput("surname", e.target.value);
              }}
              onBlur={() => handleBlur("surname")}
              type="text"
              className={`w-full pl-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow ${
                invalid.surname && touched.surname
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
              placeholder="Soyad"
            />
          </div>
          {/* Email */}
          <div className="relative">
            <EnvelopeSimpleIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
            <input
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                handleInput("email", e.target.value);
              }}
              onBlur={() => handleBlur("email")}
              type="email"
              className={`w-full pl-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow ${
                invalid.email && touched.email
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
              placeholder="E-posta"
            />
          </div>
          {/* Phone */}
          <div className="relative">
            <PhoneIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
            <input
              value={phone}
              onChange={(e) => {
                let val = e.target.value;
                if (!val.startsWith("+90"))
                  val = "+90" + val.replace(/^\+?0?/, "");
                val = val.replace(/[^\d+]/g, "");
                setPhone(val.slice(0, 13));
                handleInput("phone", val);
              }}
              onBlur={() => handleBlur("phone")}
              type="tel"
              className={`w-full pl-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow ${
                invalid.phone && touched.phone
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
              placeholder="+905XXXXXXXXX"
              maxLength={13}
            />
          </div>
          {/* Password */}
          <div className="relative">
            <LockSimpleIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
            <input
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                handleInput("password", e.target.value);
              }}
              onBlur={() => handleBlur("password")}
              type={revealPassword ? "text" : "password"}
              className={`w-full pl-9 pr-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow ${
                invalid.password && touched.password
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
              placeholder="Şifre"
            />
            {revealPassword ? (
              <EyeIcon
                className="absolute w-5 h-5 top-3 right-2.5 text-slate-500 cursor-pointer"
                onClick={() => setRevealPassword(false)}
              />
            ) : (
              <EyeClosedIcon
                className="absolute w-5 h-5 top-3 right-2.5 text-slate-500 cursor-pointer"
                onClick={() => setRevealPassword(true)}
              />
            )}
          </div>
          {/* Confirm Password */}
          <div className="relative">
            <LockSimpleIcon className="absolute w-5 h-5 top-3 left-2.5 text-slate-500" />
            <input
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                handleInput("confirmPassword", e.target.value);
              }}
              onBlur={() => handleBlur("confirmPassword")}
              type={revealConfirmPassword ? "text" : "password"}
              className={`w-full pl-9 pr-9 py-2 bg-transparent placeholder:text-gray-400 text-black text-base border rounded-md transition duration-300 ease focus:outline-none focus:border-gray-300 hover:border-gray-300 shadow-sm focus:shadow ${
                invalid.confirmPassword && touched.confirmPassword
                  ? "border-red-500"
                  : "border-gray-200"
              }`}
              placeholder="Şifre Doğrulama"
            />
            {revealConfirmPassword ? (
              <EyeIcon
                className="absolute w-5 h-5 top-3 right-2.5 text-slate-500 cursor-pointer"
                onClick={() => setRevealConfirmPassword(false)}
              />
            ) : (
              <EyeClosedIcon
                className="absolute w-5 h-5 top-3 right-2.5 text-slate-500 cursor-pointer"
                onClick={() => setRevealConfirmPassword(true)}
              />
            )}
          </div>

          {/* Error Messages */}
          {errorMessages &&
            errorMessages.length > 0 &&
            errorMessages.map((error, index) => (
              <div key={index} className="inline-flex mt-1 w-full">
                <label className="cursor-pointer ml-2 text-red-500 text-md ">
                  {error.message}
                </label>
              </div>
            ))}

          {/* Remember Me */}
          <div className="inline-flex justify-center items-center self-center w-full">
            <label
              className="flex items-center cursor-pointer relative"
              htmlFor="check-2"
            >
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={onRememberMeChange}
                className="peer h-4 w-4 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-slate-800 checked:border-slate-800"
                id="check-2"
              />
              <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  stroke="currentColor"
                  strokeWidth="1"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </span>
            </label>
            <label
              className="cursor-pointer ml-2 text-black text-sm font-medium"
              htmlFor="check-2"
            >
              Beni Hatırla
            </label>
          </div>

          {/* Submit Button */}
          <button
            className="w-full font-bold text-sm text-white py-2.5 rounded-lg text-center transition-colors duration-200 flex items-center justify-center"
            style={{ backgroundColor: "#6f59ef", minHeight: "42px" }}
            onClick={handleRegister}
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center justify-center">
                <span className="w-5 h-5 border-4 border-white border-t-transparent rounded-full animate-spin"></span>
              </span>
            ) : (
              "Kayıt Ol"
            )}
          </button>

          {/* Privacy Policy */}
          <p className="w-full text-sm text-black font-medium rounded-xl text-center mt-2">
            Devam ederek,{" "}
            <span
              onClick={onPrivacyPolicyClick}
              className="cursor-pointer"
              style={{ color: "#6f59ef", textDecoration: "none" }}
            >
              Gizlilik Politikasını
            </span>{" "}
            kabul etmiş olursunuz.
          </p>

          {/* Login Redirect */}
          <p className="w-full text-md text-black font-bold p-3 rounded-xl text-center">
            Zaten hesabınız var mı?{" "}
            <span
              onClick={onLoginClick}
              className="cursor-pointer"
              style={{ color: "#6f59ef", textDecoration: "none" }}
            >
              Giriş Yap
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}